import React from 'react'

interface SurveyErrorProps {
  messageHeader: string
  messageTxt: string
}

export default function SurveyError(props: SurveyErrorProps) {
  return (
    <>
      <section className="flex flex-col theme-survey-complete fade-in m-h-full">
      <h1 className="text-5xl md:text-7xl py-10 font-extrabold text-center"><i className="theme-error-icon fa-regular fa-message-exclamation"></i> <span className='theme-error-header'>{props.messageHeader}</span></h1>
      <div className="text-2xl theme-error-text text-center">{props.messageTxt}</div>
      </section>
    </>
  )
}


